import { Box, Chip } from "@mui/material";
import React, { FC } from "react";
import { MessageType } from "src/constants/types";

interface MessageTypeChipsProps {
  messageTypes?: MessageType[];
}

export const MessageTypeChips: FC<MessageTypeChipsProps> = (props) => {
  const { messageTypes } = props;

  if (!messageTypes?.length) {
    return null;
  }

  const isSms = messageTypes.includes("sms");
  const isMms = messageTypes.includes("mms");

  return (
    <Box sx={{ gap: 1 }}>
      {isSms && (
        <Chip
          style={{
            fontSize: "0.875rem",
            height: "initial",
          }}
          color="success"
          label="SMS"
          size="small"
          variant="outlined"
        />
      )}

      {isMms && (
        <Chip
          style={{
            fontSize: "0.875rem",
            height: "initial",
            marginLeft: "5px",
          }}
          color="primary"
          label="MMS"
          size="small"
          variant="outlined"
        />
      )}
    </Box>
  );
};
